import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconPower = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M18.4 6.6a9 9 0 1 1-12.8 0' />
      <path d='M12 2v10' />
    </g>
  </SDIcon>
)

export default IconPower
